export const isValidEmail = (email: string): boolean => {
  const atIndex = email.lastIndexOf('@')
  const dotIndex = email.lastIndexOf('.')
  return atIndex > 0 && dotIndex > atIndex
}
